// extracted by mini-css-extract-plugin
export default {"productGrid":"XY-z","centerLink":"YY-z","productSection":"ZY-z","item":"_Y-z","ctaButton":"aZ-z"};